'use client';

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { PropsWithChildren, useState, useEffect, JSX } from 'react';
import { INTERNALLY_NAVIGATING_KEY } from '@/lib/constants';

import styles from './ModalPageTransition.module.scss';
import { canAccessStorage } from '@/lib/helpers/is-storage-available';


const ModalPageTransition = ({ children }: PropsWithChildren): JSX.Element => {
  const [isInternallyNavigating, setIsInternallyNavigating] = useState(false);

  useEffect(() => {
    if(canAccessStorage('sessionStorage')) {
      setIsInternallyNavigating(sessionStorage.getItem(INTERNALLY_NAVIGATING_KEY) === 'true')
    }
  }, [])

  let classNames = `${styles.modal_page_transition}`;

  if (isInternallyNavigating) {
    classNames += ` ${styles.internal_navigation}`;
  }

  return (
    <div className={classNames}>
      {children}
    </div>
  );
};

export default ModalPageTransition;
